import { render, staticRenderFns } from "./DeliberationApprovationRoles.vue?vue&type=template&id=4028f487"
import script from "./DeliberationApprovationRoles.vue?vue&type=script&lang=js"
export * from "./DeliberationApprovationRoles.vue?vue&type=script&lang=js"
import style0 from "./DeliberationApprovationRoles.vue?vue&type=style&index=0&id=4028f487&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports